import './StatsSections.css';

function StatsSections({ sections }) {
    return sections.map((section) => {
        const rows = section.rows.filter(([, value]) => value !== null && value !== undefined && value !== '');
        if (rows.length === 0) return null;

        return (
            <div key={section.title} className="ai_chat_panel_stats_section">
                <div className="ai_chat_panel_stats_section_title">{section.title}</div>
                {rows.map(([label, value], index) => {
                    const cell = typeof value === 'object' ? value : { text: value };
                    const valueClass = 'ai_chat_panel_stats_value' + (cell.warning ? ' warning' : '') + (cell.mono ? ' mono' : '');

                    return (
                        <div key={index} className={'ai_chat_panel_stats_row' + (section.stacked ? ' stacked' : '')}>
                            {label !== null && <span className="ai_chat_panel_stats_label">{label}</span>}
                            <span className={valueClass}>{cell.text}</span>
                        </div>
                    );
                })}
                {section.note && <div className="ai_chat_panel_stats_note">{section.note}</div>}
            </div>
        );
    });
}

export default StatsSections;
